<div class="container-sidebar" fixedInViewport="true" mode="side" opened="true" disableClose="true" fxLayout="column"
    [ngClass]="!sideNavStatus?'toggleSizeIn':'toggleSizeOut'" *ngIf="sidebarOptions">
    <div class="sidebar">
        <div class="sidebar-content">
            <div class="lynxlogotipo" [ngClass]="!sideNavStatus?'showTooltip':'hideTooltip'" [routerLink]="['']" (click)="emitTitle('Home')">
                <div class="menu-item" [ngClass]="!sideNavStatus?'hideTop':'showTop'">
                    <div  [ngClass]="!sideNavStatus?'hideToggle':'showToggle'">
                        <h3 style="color:white;margin-left: 32%;"><b>{{ sidebarOptions.logoName }}</b></h3>
                    </div>
                </div>
            </div>
            <br /> <br /> <br />
            <hr style="color: white">
            <mat-accordion style="background-color: #283071;">
                <div *ngFor="let accordion of sidebarOptions.accordions">
                    <mat-expansion-panel class="mat-elevation-z0" *ngIf="accordion.visible==true" hideToggle="false"
                        #example>
                        <mat-expansion-panel-header [collapsedHeight]="'65px'" [expandedHeight]="'35px'">
                            <mat-panel-title>
                                <span>
                                    <h4>{{accordion.sidebarText | translate}}</h4>
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let s of accordion.children">
                            <div *ngIf="s.visible" class="nav-item unselectable"
                                [ngClass]="!sideNavStatus?'showTooltip':'hideTooltip'" (click)="emitTitle(s.clickTitle)"
                                routerLink="{{s.routerLink}}" [routerLinkActive]="'is-active'"
                                [routerLinkActiveOptions]="{ exact: s.exact }">
                                <span>{{s.sidebarText | translate}}</span>
                                <div class="menu-item" [ngClass]="!sideNavStatus?'hideTop':'showTop'">
                                    <i class="material-icons">{{s.sidebarIcon}}</i>
                                    <p [ngClass]="!sideNavStatus?'hideToggle':'showToggle'">{{s.sidebarText | translate
                                        }}</p>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </div>
</div>
